export default __webpack_public_path__ + "static/media/alert.c6c77ba5.svg";